<template>
  <iframe :src="src" />
</template>

<script>
export default {
    name: 'IframeBox',
    props: {
        src: {
            type: String,
            required: true
        },
        cssClass: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
iframe {
    height: auto;
    background: white;
}
</style>